exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-layout>*{position:relative}.clearfix{*zoom:1}.clearfix:after,.clearfix:before{content:\" \";display:table;line-height:0}.clearfix:after{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/Layout.less
// module id = 166
// module chunks = 0